import { RadioButtonSizes } from '../../../../atoms/radio-button/types';
var EPS = 3;
export var COLOR_DOT_SIZE = Number(RadioButtonSizes.Size_4);
export var MAX_COLORS_PER_VIEW = 7;
export var colorDotsInterpolation = function (itemWidth, containerWidth, gap) {
    if (gap === void 0) { gap = 0; }
    var value = MAX_COLORS_PER_VIEW;
    if (containerWidth && itemWidth && itemWidth > 0) {
        var dots = Math.trunc(containerWidth / itemWidth);
        value = Math.min(Math.max(1, Math.trunc(dots * (1 - gap) - EPS)), MAX_COLORS_PER_VIEW);
    }
    return value;
};
